// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.tooltip-white-text {
  color: #f9f9f9;
}
.tooltip-list {
  list-style-type: disc !important;
  padding-left: 20px !important;
}
.tooltip-list li {
  list-style-type: disc !important;
  font-size: inherit;
  line-height: inherit;
  border-bottom: none !important;
}
.tooltip.b-tooltip {
  opacity: 0.85 !important;
}
.tooltip .tooltip-inner {
  background-color: #044080 !important;
  color: white !important;
}
.bs-tooltip-top .arrow::before {
  border-top-color: #044080 !important;
}
.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #044080 !important;
}
.my-tooltip-class .tooltip-inner {
  max-width: 600px !important;
  width: 600px !important;
  text-align: left !important;
  opacity: 1 !important;
}
.budget-request {
  background-color: #F3F5F7;
}
.budget-request .wrapper-icon {
  position: relative;
  left: 5px;
  top: -2px;
}
.budget-request .wrapper-icon .icon-info {
  border: 2px solid #adadad;
  padding: 3px;
  font-size: 20px;
  border-radius: 20px;
  width: 20px;
  color: #adadad;
  cursor: pointer;
}
.budget-request .icon-date {
  position: relative;
  color: #adadad;
  float: right;
  pointer-events: none;
  bottom: 27px;
  right: 11px;
}
.budget-request .planning h6 {
  font-weight: bold;
}
.budget-request .form-row.planning {
  overflow-x: auto;
  overflow-y: hidden;
}
.budget-request .nameReview {
  word-break: break-all;
}
.budget-request .container-fluid h5 {
  color: #adadad;
  font-size: 1em;
}
.budget-request h6 {
  font-size: 1.1em;
  font-weight: normal;
}
.budget-request .border-row {
  border-bottom: 1px solid #adadad;
}
.budget-request .border-top-row {
  border-top: 1px solid #adadad;
}
.budget-request .icon-cancel {
  font-size: 2.08rem;
  padding-right: 6px;
  position: relative;
}
@media (max-width: 576px) {
.budget-request .icon-cancel {
    font-size: 1.6rem;
    padding-right: 5px;
}
}
.budget-request .menu-save {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}
.budget-request .menu-save a {
  margin-left: 45px;
}
@media (max-width: 1600px) {
.budget-request .menu-save a {
    margin-left: 20px;
}
}
@media (max-width: 576px) {
.budget-request .menu-save a {
    margin-left: 10px;
    font-size: 15px;
}
}
.budget-request .menu-save a:first-child {
  color: #4d4d4d;
}
.budget-request .menu-save a:nth-child(2) {
  color: #4d4d4d !important;
}
.budget-request label {
  padding-left: 15px;
  font-size: 1.44rem;
}
.budget-request .sameSize {
  min-width: 150px;
  text-align: center;
}
.budget-request .sameSize ~ .sameSize {
  margin-left: 10px;
}
.budget-request .aero-button {
  min-width: 150px;
  text-align: center;
}
.budget-request .aero-button ~ .aero-button {
  margin-left: 10px;
}
.budget-request .btn {
  background-color: transparent;
  cursor: default;
}
.budget-request .card-header button.btn {
  padding-left: 20px;
}
.budget-request button:focus {
  box-shadow: none;
}
.budget-request h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
  text-transform: uppercase;
}
.budget-request .accordion-budget-details {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.budget-request .accordion-early-approval {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.budget-request .accordion-finance-budget {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 4.8rem;
}
.budget-request .accordion-help {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.budget-request .accordion-review {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.budget-request .vis-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.budget-request input[type=radio]:checked + label {
  background-color: #0078dc;
  color: white;
  transition: 0.3s;
}
.budget-request input[type=radio] + label {
  border: 1px solid #adadad;
  padding: 8px;
  border-radius: 4px;
  font-weight: normal;
  cursor: pointer;
}
.budget-request .form-control {
  border: 1px solid #adadad;
  height: calc(1.5em + 1.2rem + 6px);
}
.budget-request #inputComment.form-control,
.budget-request #impactDescription.form-control {
  height: auto !important;
}
.budget-request .form-control[readonly],
.budget-request .form-control[disabled] {
  background-color: #eaeaea;
}
.budget-request .form-control::placeholder {
  color: #adadad;
  opacity: 0.65;
  font-weight: normal;
}
.budget-request input[type=date] {
  color: #adadad;
}
.budget-request input[type=date]:focus {
  color: #495057;
}
.budget-request input[type=date] {
  position: relative;
  padding: 10px;
}
.budget-request input[type=date]::-webkit-calendar-picker-indicator {
  color: transparent;
  background: none;
  z-index: 1;
}
.budget-request input[type=date]:before {
  color: transparent;
  background: none;
  display: block;
  font-family: "FontAwesome";
  content: "";
  /* This is the calendar icon in FontAwesome */
  width: 15px;
  height: 20px;
  position: absolute;
  top: 12px;
  right: 6px;
  color: #999;
}
.budget-request table.planning-table th {
  border-right: 1px solid #adadad;
  border-bottom: 1px solid #adadad;
  text-align: center;
}
@media (min-width: 1023px) {
.budget-request table.planning-table th {
    width: 130px;
    padding: 15px;
}
}
.budget-request table.planning-table th:last-child {
  border-right: none;
}
.budget-request table.planning-table td {
  border-right: 1px solid #adadad;
  text-align: left;
  padding: 15px 0;
  text-align: center;
  background-color: #f9f9f9;
}
.budget-request table.planning-table td input {
  background-color: transparent;
  outline: none;
  border: none;
  text-align: center;
  width: 100%;
}
.budget-request table.planning-table td:last-child {
  border-right: none;
}
.budget-request .multiselect__placeholder {
  margin-bottom: 8px;
  padding-top: 0px;
  font-size: 16px;
  padding-left: 10px;
  opacity: 0.65;
}
.budget-request .mx-datepicker input {
  cursor: pointer;
}
.budget-request .vdp-datepicker .form-control.is-invalid {
  border: unset !important;
  position: absolute;
  top: 0;
  z-index: -1;
}
.budget-request .vdp-datepicker .form-control[readonly] {
  background-color: white !important;
}
.budget-request .accordion-connection {
  font-size: 1.44rem;
}
.budget-request .accordion-connection .btn-primary {
  border-radius: 2.08rem;
  background-color: #0062cc;
  padding: 10px 60px;
  box-shadow: none !important;
  border: none;
}
.budget-request .accordion-connection p {
  line-height: 1.2;
}
.budget-request .connection-text small {
  font-size: 85%;
}
.budget-request .external a {
  font-size: 1.44rem;
  color: #0078dc !important;
  cursor: pointer;
  font-weight: 600;
  line-height: 2.5;
}
.budget-request .warning {
  border-color: #fd7e14;
}
.budget-request .warning-label {
  color: #fd7e14;
}
.budget-request .container-fluid h5.warning-label {
  color: #fd7e14;
}
.budget-request .external-slider {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background-color: #fff;
}
.budget-request .slick-next:before, .budget-request .slick-prev:before {
  color: #0078dc;
  font-size: 2.4rem;
}
.budget-request .slick-prev {
  left: 43%;
  z-index: 2;
  top: unset;
  bottom: 3px;
}
.budget-request .slick-next {
  left: 51%;
  z-index: 2;
  top: unset;
  bottom: 3px;
}
@media (max-width: 992px) {
.budget-request h5.warning-label {
    font-size: 15px;
}
.budget-request h5.text-danger {
    font-size: 15px;
}
.budget-request .accordion-finance-budget {
    margin-bottom: 2.4rem;
}
}
@media (max-width: 576px) {
.budget-request .planning-table th, .budget-request .planning-table td {
    font-size: 12px;
}
.budget-request .connection-text small {
    font-size: 80%;
}
}
@media (min-width: 1200px) and (max-width: 1375px) {
.budget-request .sameSize {
    min-width: 125px;
    width: 49%;
}
}
.multiselect__placeholder {
  color: #adadad !important;
  font-weight: normal !important;
}
.multiselect.is-invalid {
  border: 1px solid red !important;
}
.multiselect.is-invalid .multiselect__tags {
  border: none !important;
}
.multiselect.is-invalid.form-control {
  padding: unset !important;
}
.selector--disabled label {
  color: rgb(173, 173, 173);
  border-color: rgb(173, 173, 173);
  user-select: none;
}
.cursor-blocked {
  cursor: no-drop !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
